import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../../store/reportStore';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { repiActions, repiDomain, repiLimits } from '../../../../store/repiStore';
import HistoryLink from '../../../common/historyLink';
import RepiContractDetail from './repiContractDetail';
import RepiContractHeader from './repiContractHeader';

import '../../repi.scss';

class RepiContract extends React.Component {
    state = {
        showHistory: true,
        page: 1
    };

    render() {
        const { contract, contractIndex } = this.props;

        return (
            <div key={contract.contractId} className={classnames("repi-contract-container", {
                last: (contractIndex + 1) % repiLimits.paymentHistoryContracts === 0,
                first: (contractIndex + 1) % repiLimits.paymentHistoryContracts === 1
            })}>
                <RepiContractHeader contract={contract}
                    contractIndex={contractIndex + 1}
                    isInternalDataCorrection={this.props.isDataCorrection(true)}
                    isAnyDataCorrection={this.props.isDataCorrection()}
                    isSubject={this.props.isSubject()}
                    isPlus={this.props.isPlus()}
                    domain={this.props.domain}
                />
                {this.renderContractPaymentHistory(contract)}
            </div>
        );
    }

    renderContractPaymentHistory = (contract) => {
        if (isNullOrUndefined(contract) || isNullOrUndefined(contract.payments) || contract.payments.length === 0)
            return null;

        return (
            <div className="repi-contract-history lpad-1-5 rpad-1-5">
                <div className="columns is-gapless is-desktop">
                    <div className="column is-half repi-contract-history-link-wrapper">
                        <HistoryLink isOrange={true} onClick={() => this.setState({ showHistory: !this.state.showHistory })}
                            historyExpanded={this.state.showHistory}
                        />
                    </div>
                    <div className="column" />
                </div>
                <Collapse isOpen={this.state.showHistory}>
                    <RepiContractDetail contract={contract} pageLimit={repiLimits.paymentHistoryContracts} getDunningLevel={this.getDunningLevel} />
                </Collapse>
            </div>
        );
    }


    getDunningLevel = (dunningLevel) => {
        const result = this.getDomainData(repiDomain.dunningLevels, dunningLevel)
        return isNullOrUndefined(result) ? "" : this.props.translate(`Repi.DunningLevel.${result.shortening}`);
    }

    getCurrency = (code) => {
        const result = this.getDomainData(repiDomain.currencies, code)
        return isNullOrUndefined(result) ? "" : (result.shortening || "").toUpperCase();
    }

    getDomainData = (domain, value) => {
        if (isNullOrUndefined(value) || isNaN(parseInt(value)))
            return null;

        if (isNullOrUndefined(this.props.domain) || isNullOrUndefined(this.props.domain[domain]) ||
            isNullOrUndefined(this.props.domain[domain].requestResult))
            return null;

        return this.props.domain[domain].requestResult.find(f => parseInt(f.value) === parseInt(value));
    }
}

export default connect(
    state => ({ ...state.repi.props,
        contractHeader: { ...state.repi.dataCorrection }
    }),
    dispatch => bindActionCreators({ ...repiActions, ...reportActions }, dispatch)
)(withLocalize(withRouter(RepiContract)));